import { LiveAnnouncer } from '@angular/cdk/a11y';
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import { Component, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Router } from '@angular/router';
import { FranchiseModel } from 'src/app/models/franchise.model';
import { ToastService } from 'src/app/services/toast.service';
import { WorkloadsService } from 'src/app/services/workloads.service';
import { SharedServices } from 'src/app/shared/services/shared.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { FranchiseModalComponent } from './franchise-modal/franchise-modal.component';
import { take } from 'rxjs';
import { ComponentType } from '@angular/cdk/portal';
import { PointSaleComponent } from './point-sale/point-sale.component';
import { NgClass } from '@angular/common';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';

import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

import { MatIcon } from '@angular/material/icon';
@Component({
    selector: 'app-franchise',
    templateUrl: './franchise.component.html',
    styleUrls: ['./franchise.component.scss'],
    imports: [IconMenuButtonComponent, PageHeaderComponent, EmptyStateComponent, MatIcon, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatMenu, MatMenuItem, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, NgClass, MatPaginator, MatButton]
})
export class FranchiseComponent {
  toastr = inject(ToastService);
  private readonly _liveAnnouncer = inject(LiveAnnouncer);
  franchiseSvc = inject(WorkloadsService);
  private readonly router = inject(Router);
  private readonly sharedService = inject(SharedServices);
  private readonly swalFireAndPaginator = inject(CommonFunctionsConfiguratorService);
  dialog = inject(MatDialog);


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  FranchiseModalComponent = FranchiseModalComponent;
  PointSaleComponent = PointSaleComponent

  public displayedColumns: string[] = [
    'franchise',
    'companyName',
    'city',
    'address',
    'menu',
  ];
  public franchises: FranchiseModel[] = [];
  public dataSource = new MatTableDataSource<FranchiseModel>();
  public selectedFranchiseToEdit?: FranchiseModel;

  ngOnInit() {
    this.getFranshices();
  }

  getFranshices() {
    this.franchiseSvc.getAllFranchises().pipe(take(1)).subscribe({
      next: (data) => {
        this.franchises = data;
        this.dataSource = new MatTableDataSource(this.franchises);
        this.swalFireAndPaginator.configurePaginator(
          this.dataSource,
          this.paginator,
          this.sort,
          "Franquicias"
        );
      },
      error: (err) => {
        this.toastr.error('Error', 'Error al obtener las franquicias.');
      },
    });
  }

  deleteFranchise(franchiseId: string) {
    this.swalFireAndPaginator
      .SwalFireQuestion(
        'Eliminar franquicia',
        '¿Está seguro que desea eliminar la franquicia?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.franchiseSvc.deleteFranchise(franchiseId, false).subscribe({
            next: (data) => {
              this.toastr.success(
                'Franquicia eliminada',
                ' La franquicia se elimino correctamente'
              );
              this.getFranshices();
            },
            error: (err) => {
              this.toastr.error(
                'Error',
                'Error no se pudo eliminar la franquicia.'
              );
            },
          });
        }
      });
  }

  goPointSale(franchise: FranchiseModel) {
    this.router.navigate(['/franchis-point-sales'], {
      queryParams: { id: franchise.id, companyName: franchise.companyName },
    });
  }

  goFranchiseZone(franchise: FranchiseModel) {
    this.router.navigate(['/franchis-zone'], {
      queryParams: { id: franchise.id, companyName: franchise.companyName },
    });
  }

  goFranchise(franchise: FranchiseModel) {
    this.sharedService.selectedFranchise = franchise;
  }

  onRowKeydown(event: KeyboardEvent, element: any) {
    if (event.key === 'Enter') {
      this.goFranchise(element);
    }
  }

  announceSortChange(sortFranchises: Sort) {
    if (sortFranchises.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortFranchises.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  dialogAction<T>(component: ComponentType<T>, event?: any): void {
    let currentDialog = this.dialog.open(component, {
      width: '560px',
      maxWidth: '95vw',
      maxHeight: '95vh',

      data: { franchiseData: event, action: event ? 'edit' : 'create' },
    });

    currentDialog.afterClosed().subscribe(() => {
      this.getFranshices();
    });
  }
}
